import { useCallback } from 'react';

import { useActorRef } from '@xstate5/react';

import { useAppState } from '@sg/garnish';
import { otaMachine } from '@sg/ota-installer';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { otaLogger } from './helpers';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitOtaActor = () => {
  const appState = useAppState();

  const pollingIntervalInMinutes = useFeatureFlag('CELS-4466-order-in-app-ota-polling-interval');

  // ─── Guards ──────────────────────────────────────────────────────────

  const checkIfAppIsReady = useCallback(() => appState === 'active', [appState]);

  // ─────────────────────────────────────────────────────────────────────

  return useActorRef(
    otaMachine.provide({
      delays: { POLLING_INTERVAL: pollingIntervalInMinutes * 60 * 1000 },
      guards: { 'check-if-app-is-ready': checkIfAppIsReady },
    }),
    { input: { logger: otaLogger, shouldUseLaunchTimeGate: true } },
  );
};
